import styled from "styled-components";

export const LetterModal = styled("h3")`
  font-size: ${(props) => (!!props.lg ? "16px" : "10px")};
  color: ${(props) => (!!props.gray ? "#777" : "#000")};
  font-weight: 500;
  line-height: 1.2;
`;
